import { PayrollSummaryToDate } from "../types";
import * as PayrollService from "@/shared/api/payrollService";
import { FetchState } from "@/shared/types";
import * as storeHelper from "@/shared/storeHelper";
import { defineStore } from "pinia";
import _ from "lodash";

export const initialState: PayrollSummaryToDate = {
    fetchState: FetchState.Uninitialized,
    employer: {
        pending: null,
        processed: null
    },
    employee: {
        pending: null,
        processed: null
    }
};

export const usePayrollSummaryToDateStore = defineStore("payrollSummaryToDate", {
    state: (): PayrollSummaryToDate => (_.cloneDeep(initialState)),
    getters: {
        employerSummary: state => state.employer,
        employeeSummary: state => state.employee
    },
    actions: {
        setFetchState (
            commitState: { fetchState: FetchState, employeeKey: string }): void {
            this.fetchState = commitState.fetchState;
            this.employeeKey = commitState.employeeKey;
        },
        setSummaryToDate (commitState: { data: PayrollSummaryToDate, key: string }) {
            // it's possible the promises resolve out of order... ensure the key matches
            if (this.employeeKey === commitState.key) {
                this.employer = commitState.data.employer;
                this.employee = commitState.data.employee;
            }
        },
        clearSummaryToDate () {
            this.employee = null;
            this.employer = null;
        },
        clearFetchStateError (employeeKey: string) {
            // it's possible the promises resolve out of order... ensure the key matches before clearing things out
            if (this.employeeKey === employeeKey) {
                this.fetchState = FetchState.Uninitialized;
                this.employeeKey = null;
                this.employee = null;
                this.employer = null;
            }
        },
        getEmployeeYearToDatePayroll (
            request: { employerId: number, externalEmployeeId: string }) {
            const employeeKey = `${request.employerId}-${request.externalEmployeeId}`;
            if (this.employeeKey === employeeKey) return;

            this.clearSummaryToDate();
            this.setFetchState({ fetchState: FetchState.Loading, employeeKey });

            return PayrollService
                .getEmployeeYearToDatePayroll(request.employerId, request.externalEmployeeId)
                .then(response => {
                    this.setSummaryToDate({ key: employeeKey, data: response.data });
                    this.setFetchState({ fetchState: FetchState.Loaded, employeeKey });
                })
                .catch(err => {
                    this.clearFetchStateError(employeeKey);
                    return storeHelper.handleError({ error: err, rethrow: true });
                });
        },
    }
});